module.exports = __webpack_public_path__ + "img/btn_menu_goods.ac45a2cd.svg";